import React, { Component } from 'react'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'
import classnames from 'classnames'
import "whatwg-fetch"

import TInputForm from "../../../common/TInputForm"
import TTextareaForm from "../../../common/TTextareaForm"

import * as SaveStatus from '../../../../constants/SaveStatus'
import { receiveInfo } from '../../../../actions/setting/blog'
import { jsonResponseHandler } from "../../../../utils/FetchHelper"
import TSubmitButtonForm from "../../../common/TSubmitButtonForm";
import {addPrefix} from "../../../../utils/UriUtil";

const MAX_BLOG_TITLE_LENGTH = 40;

@connect(state => ({
	info: state.setting.blog.info
}), dispatch => ({
	handleReceiveInfo(name, info) {
		dispatch(receiveInfo(info))
	},
  dispatch
}))
class BlogInfoForm extends Component {
	
	constructor(props, context) {
		super(props, context)
	  const { title: blogTitle } = props.info

		this.state = Object.assign({
      /* 블로그명 길이 제한 패치 전 블로그명이 이미 40자를 초과했던 블로그들에 대한 플래그 */
      isBlogTitleLengthValid: blogTitle.length <= MAX_BLOG_TITLE_LENGTH,
			saveStatus: SaveStatus.READY,
      changed: false
		}, props.info)
	}

	componentDidMount() {
    if (!this.state.isBlogTitleLengthValid) {
	    this.truncateBlogTitle()
      alert(`블로그 이름을 ${ MAX_BLOG_TITLE_LENGTH }글자 이하로 설정해주세요.`)
    }
  }

  /**
   * 블로그 명이 40자를 초과하는 블로그는 블로그명을 truncate 후 표기한다.
   */
  truncateBlogTitle() {
	  const { title } = this.state
	  this.setState({
      title: title.substring(0, MAX_BLOG_TITLE_LENGTH)
	  })
  }

  @autobind
	handleChangeTitle(value) {
		this.setState({
			title: value,
      changed: this.isChangedAndValid({title: value})
		})
	}

	@autobind
	handleChangeDescription(value) {
		this.setState({
			description: value,
      changed: this.isChangedAndValid({description: value})
		})
	}

	@autobind
	handleSubmit(e) {
		e.preventDefault();

		const { name, title, description, saveStatus } = this.state
		const { info, handleReceiveInfo, dispatch } = this.props

		if (saveStatus === SaveStatus.DOING) {
			return
		}

		let data = {
			title, description
		}

		this.setState({
			saveStatus: SaveStatus.DOING
		})
		fetch(addPrefix("/manage/setting/blog/blogInfo.json"), {
			method: 'post',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		})
			.then(jsonResponseHandler(dispatch))
			.then(() => {
				this.setState({
					saveStatus: SaveStatus.DONE,
          changed: false
				})
				handleReceiveInfo(name, Object.assign(info, data))
			})
			.catch(e => {
				console.error(e)
				this.setState({
					saveStatus: saveStatus
				})
			})
	}

	isChangedAndValid(changedInputData) {
    const changedInfo = Object.assign(this.state, changedInputData)
		const { info } = this.props

		let changed = changedInfo.title !== info.title || changedInfo.description !== info.description
		let valid = changedInfo.title !== ''

		return changed && valid
	}
	
	render() {
		const { title, description, saveStatus, changed } = this.state
		let status = saveStatus
		if (saveStatus !== SaveStatus.DOING && changed) {
			status = SaveStatus.CAN_SUBMIT
		}


		return (
			<form className="wrap_set" onSubmit={this.handleSubmit}>

				<fieldset className="fld_name">
					<legend className="screen_out">블로그 이름 설정</legend>
					<label className="lab_tf">
						<strong className="tit_set">블로그 이름</strong>
						<TInputForm type="text" className="tf_blog" value={title} onChange={this.handleChangeTitle} maxlength={MAX_BLOG_TITLE_LENGTH.toString()} />
					</label>
					<p className={classnames("txt_required hide", { "hide": title !== '' })}>
						블로그 이름을 입력해주세요
					</p>
					<div className="lab_tf">
						<strong className="tit_set">블로그 설명</strong>
						<TTextareaForm className="tf_blog" defaultValue={description} onChange={this.handleChangeDescription} />
					</div>
				</fieldset>

				<fieldset>
					<legend className="screen_out">저장 버튼</legend>
					<TSubmitButtonForm type="submit" status={status} />
				</fieldset>
			</form>
		)
	}
}

export default BlogInfoForm
